export { Slides } from "./slides";
export { ImageSlide } from "./image-slide";
export { VideoSlide } from "./video-slide";
export { ContentSlide } from "./content-slide";
export type { SlideTypes, ContentSlideProps } from "./interface";
